import {
  HOME_GOOGLE_AGGREGATE_RATING,
  buildHomeLocalBusinessReviewsSchema,
} from "./homeReviewsSeo";

const SITE_ORIGIN = "https://www.indiaboats.in";
export const BUSINESS_ID = `${SITE_ORIGIN}/#business`;
export const ORGANIZATION_ID = `${SITE_ORIGIN}/#organization`;
export const WEBSITE_ID = `${SITE_ORIGIN}/#website`;
export const MEHUL_ASHAR_ID = `${SITE_ORIGIN}/about#mehul-ashar`;

const LOGO_URL = `${SITE_ORIGIN}/assets/img/ib_red_logo.png`;
const AREA_SERVED = ["Mumbai", "Goa"];

/** Standalone Person block (About page) — same fields as Appendix B founder. */
export const MEHUL_ASHAR_PERSON_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Person",
  "@id": MEHUL_ASHAR_ID,
  name: "Mehul Ashar",
  jobTitle: "Founder and CEO",
  description:
    "Decorated national sailing champion with more than 35 years of competitive sailing, including Asian regattas and World Championships.",
};

/** Appendix B — homepage JSON-LD (Organization, LocalBusiness ×2, WebSite). */
export const HOME_PAGE_SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": ORGANIZATION_ID,
    name: "India Boats",
    legalName: "Aquartia Pvt. Ltd.",
    url: `${SITE_ORIGIN}/`,
    logo: LOGO_URL,
    foundingDate: "2016-08",
    founder: {
      "@type": "Person",
      "@id": MEHUL_ASHAR_ID,
      name: "Mehul Ashar",
      jobTitle: "Founder and CEO",
      description:
        "Decorated national sailing champion with more than 35 years of competitive sailing, including Asian regattas and World Championships.",
    },
    email: "customercare@indiaboats.in",
    telephone: "+91-8591993301",
    sameAs: [
      "https://www.facebook.com/indiaboats.in/",
      "https://www.instagram.com/india_boats/",
      "https://x.com/india_boats",
      "https://www.youtube.com/channel/UC9sFJ9TzZTm9OupLqxd02wA",
      "https://www.linkedin.com/company/india-boats/",
      "https://www.tripadvisor.in/Attraction_Review-g304554-d10264828-Reviews-India_Boats-Mumbai_Maharashtra.html",
      "https://yourstory.com/companies/india-boats",
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "TravelAgency"],
    "@id": BUSINESS_ID,
    name: "India Boats",
    url: `${SITE_ORIGIN}/`,
    image: LOGO_URL,
    logo: LOGO_URL,
    description:
      "Private yacht charters, yacht parties, speed boat transfers to Mandwa, Alibaug and Elephanta, curated boat packages and corporate sailing regattas in Mumbai and Goa.",
    telephone: "+91-8591993301",
    aggregateRating: HOME_GOOGLE_AGGREGATE_RATING,
    review: buildHomeLocalBusinessReviewsSchema(),
    contactPoint: [
      {
        "@type": "ContactPoint",
        telephone: "+91-8591993301",
        contactType: "customer service",
        availableLanguage: ["English", "Hindi"],
      },
      {
        "@type": "ContactPoint",
        telephone: "+91-22-6695-8111",
        contactType: "office landline",
      },
    ],
    email: "customercare@indiaboats.in",
    priceRange: "₹₹₹",
    parentOrganization: { "@id": ORGANIZATION_ID },
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "803, Hubtown Viva, Western Express Highway, Jogeshwari East",
      addressLocality: "Mumbai",
      addressRegion: "Maharashtra",
      postalCode: "400060",
      addressCountry: "IN",
    },
    areaServed: [
      { "@type": "City", "name": "Mumbai" },
      { "@type": "State", "name": "Goa" },
    ],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "India Boats experiences",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Private yacht charter",
            url: `${SITE_ORIGIN}/private-yacht-charter-mumbai-goa`,
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Yacht party",
            url: `${SITE_ORIGIN}/yacht-party-mumbai`,
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Speed boat transfer",
            url: `${SITE_ORIGIN}/speedboat`,
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Alibaug and Elephanta boat tours",
            url: `${SITE_ORIGIN}/alibaug-elephanta-boat-tours-mumbai`,
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Corporate sailing regatta",
            url: `${SITE_ORIGIN}/corporate-sailing-regatta-mumbai`,
          },
        },
      ],
    },
  },
  {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "TravelAgency"],
    "@id": `${SITE_ORIGIN}/#jetty`,
    name: "India Boats",
    url: `${SITE_ORIGIN}/`,
    image: LOGO_URL,
    description:
      "Boarding point for India Boats private yachts, yacht parties and speed boats at Gateway of India.",
    telephone: "+91-8591993301",
    email: "customercare@indiaboats.in",
    priceRange: "₹₹₹",
    parentOrganization: { "@id": ORGANIZATION_ID },
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "Jetty No. 5, opp. Taj Mahal Hotel, Apollo Bandar, Colaba",
      addressLocality: "Mumbai",
      addressRegion: "Maharashtra",
      postalCode: "400001",
      addressCountry: "IN",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 18.9218381,
      longitude: 72.8336751,
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": WEBSITE_ID,
    url: `${SITE_ORIGIN}/`,
    name: "India Boats",
    publisher: { "@id": ORGANIZATION_ID },
    inLanguage: "en-IN",
  },
];

/** @id reference for Contact and other pages that mention the business entity. */
export const LOCAL_BUSINESS_REFERENCE = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": BUSINESS_ID,
};

export const SERVICE_PROVIDER = { "@id": BUSINESS_ID };

export const buildServiceSchema = (serviceType, description) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType,
  provider: SERVICE_PROVIDER,
  areaServed: AREA_SERVED,
  description,
});

export const buildFaqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map(({ question, answer }) => ({
    "@type": "Question",
    name: question,
    acceptedAnswer: {
      "@type": "Answer",
      text: answer,
    },
  })),
});

export const ORGANIZATION_REFERENCE = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": ORGANIZATION_ID,
};

export const buildBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: item.url,
  })),
});

const HOME_CRUMB = { name: "Home", url: `${SITE_ORIGIN}/` };
const EXPERIENCES_HUB_CRUMB = {
  name: "Experiences",
  url: `${SITE_ORIGIN}/packages`,
};
const FLEET_HUB_CRUMB = {
  name: "Fleet",
  url: `${SITE_ORIGIN}/private-yacht-charter-mumbai-goa`,
};

export const buildGuideBreadcrumbSchema = (pageName, pageUrl) =>
  buildBreadcrumbSchema([
    HOME_CRUMB,
    EXPERIENCES_HUB_CRUMB,
    { name: pageName, url: pageUrl },
  ]);

export const buildFleetBreadcrumbSchema = (boatName, boatUrl) =>
  buildBreadcrumbSchema([
    HOME_CRUMB,
    FLEET_HUB_CRUMB,
    { name: boatName, url: boatUrl },
  ]);

const PRIVATE_YACHT_FAQS = [
  {
    question: "What types of private yachts can I book in Mumbai?",
    answer:
      "You can explore private yacht charter options in Mumbai across categories such as sail boats, compact yachts, mid size yachts, premium yachts and bigger sail yachts.",
  },
  {
    question: "How do I choose the right yacht category?",
    answer:
      "The right yacht depends on your group size, occasion, comfort preference and the type of private sea experience you want. Indiaboats can help recommend the best option.",
  },
  {
    question: "Are sail boats and yachts both available for private charter?",
    answer:
      "Yes. Indiaboats offers both sail boats and private yachts in Mumbai for guests looking for different styles of on-water experience.",
  },
  {
    question: "Is a compact yacht suitable for couples and small families?",
    answer:
      "Yes. Compact yachts are ideal for couples, small families and close groups looking for a private and comfortable yacht experience.",
  },
  {
    question: "What is the benefit of choosing a premium yacht?",
    answer:
      "Premium yachts offer more space, stronger comfort, better onboard experience and a more elevated private yacht charter feel.",
  },
  {
    question: "Can I book a private yacht for a birthday or anniversary?",
    answer:
      "Yes. Private yacht charters in Mumbai are a popular choice for birthdays, anniversaries and intimate celebrations.",
  },
  {
    question: "Is a private yacht charter in Mumbai safe?",
    answer:
      "Yes. Indiaboats places strong emphasis on trained crew, guest support and responsible operations.",
  },
  {
    question: "How do I enquire for a private yacht charter in Mumbai?",
    answer:
      "You can contact Indiaboats through the enquiry form or WhatsApp with your date, guest count and occasion.",
  },
];

const YACHT_PARTY_FAQS = [
  {
    question: "Can I book a specific yacht by name for a yacht party in Mumbai?",
    answer:
      "Yes — you can browse real yachts by name on Indiaboats, compare capacity and features, and book the yacht you want for your party.",
  },
  {
    question: "Will each yacht card have a direct booking link?",
    answer:
      "Yes. Each yacht listing card includes a direct 'Book Now' link along with a 'View Details' option to streamline your reservation process.",
  },
  {
    question: "What information should each yacht card show?",
    answer:
      "Each listing shows the yacht name, photos, size, guest capacity, a short description for celebrations, and options to book or view full details.",
  },
  {
    question: "Can I compare yachts by size and guest capacity?",
    answer:
      "Yes — you can compare yacht size, guest capacity and suitability for your celebration side by side before you book.",
  },
  {
    question: "Are these yacht party options suitable for birthdays and anniversaries?",
    answer:
      "Yes. Yacht parties in Mumbai are a highly popular choice for premium milestone birthdays, romantic anniversaries, and elite private celebrations.",
  },
  {
    question: "Can I book a yacht for a small private group?",
    answer:
      "Yes. Smaller yacht and compact cruiser options are ideal for intimate celebrations, close friend group gatherings, and private family dinners.",
  },
  {
    question: "Is a yacht party in Mumbai safe?",
    answer:
      "Yes. Indiaboats places a strong emphasis on a highly trained marine crew, constant guest support, and completely responsible, certified operations.",
  },
  {
    question: "How do I enquire if I am not sure which yacht to choose?",
    answer:
      "You can instantly contact Indiaboats through the on-page enquiry form or via WhatsApp with your target date, guest count, and celebration type for personalized recommendations.",
  },
];

export const SPEED_BOAT_FAQS = [
  {
    question: "How long does a speed boat take from Mumbai to Mandwa?",
    answer:
      "Usually about 20 to 30 minutes from the Gateway of India, depending on sea conditions. The same journey by road can take three hours or more.",
  },
  {
    question: "Where does the speed boat depart from in Mumbai?",
    answer:
      "Transfers depart from the Gateway of India. Our team shares the exact jetty and boarding time when you book.",
  },
  {
    question: "Are speed boat transfers available from Mumbai to Mandwa and Alibaug?",
    answer:
      "Yes. Private speed boat transfers from Mumbai to Mandwa and Alibaug are available for guests looking for fast and convenient sea travel.",
  },
  {
    question: "Do you offer private speed boat trips to Elephanta?",
    answer:
      "Yes. Private speed boat trips from Mumbai to Elephanta are available for sightseeing, family visits and private island travel.",
  },
  {
    question: "Can I book a one-way or a return transfer?",
    answer:
      "Yes. You can book a one-way or a two-way (return) transfer on both the Mandwa and Alibaug route and the Elephanta route.",
  },
  {
    question: "What guest capacities are available for a private speed boat?",
    answer:
      "Private speed boats are available for groups of 6, 8, 10, 12, 15 and 18 guests. Tell us your group size and we will recommend the right boat.",
  },
  {
    question: "Do speed boats run during the monsoon?",
    answer:
      "Open-sea speed boat services pause during the monsoon under Maharashtra Maritime Board rules, usually from late May to the end of August. Contact us for this year's dates.",
  },
  {
    question: "Is a private speed boat transfer from Mumbai safe?",
    answer:
      "Yes. Every transfer runs with a trained crew, life jackets for every guest and a safety briefing before departure.",
  },
  {
    question: "How do I book a speed boat transfer?",
    answer:
      "Call +91 85919 93301 or WhatsApp +91 79 7757 4228 with your date, route and number of guests. Our team will confirm the right boat and the price.",
  },
];

const REGATTA_FAQS = [
  {
    question: "What is a corporate sailing regatta in Mumbai?",
    answer:
      "A corporate sailing regatta in Mumbai is a team-building sailing experience where employees or business groups take part in a structured on-water format designed to build teamwork, communication and leadership.",
  },
  {
    question: "How is a corporate sailing regatta different from a regular team outing?",
    answer:
      "A regular team outing is usually passive and social, while a sailing regatta is interactive and participation-led, which makes it more effective for team building and engagement.",
  },
  {
    question: "Why is a sailing regatta good for team building?",
    answer:
      "It naturally encourages communication, collaboration, decision-making, trust and shared achievement, which are all important team qualities.",
  },
  {
    question: "What happens during a corporate sailing regatta?",
    answer:
      "The experience may include briefing, team formation, guided sailing participation, regatta-style activity and shared team moments on the water.",
  },
  {
    question: "Is this suitable for leadership teams?",
    answer:
      "Yes. Corporate sailing regattas work very well for leadership groups because they highlight strategy, calm decision-making and teamwork in a live environment.",
  },
  {
    question: "What business goals can a corporate sailing regatta support?",
    answer:
      "It can support team building, employee engagement, leadership development, offsites, reward events and culture-building initiatives.",
  },
  {
    question: "How is Indiaboats different for corporate regattas?",
    answer:
      "Indiaboats focuses on premium on-water corporate experiences and helps companies create sailing regattas that feel structured, meaningful and memorable.",
  },
  {
    question: "How do I enquire about a corporate sailing regatta in Mumbai?",
    answer:
      "You can enquire through WhatsApp or the contact form and share your preferred date, team size and event objective.",
  },
];

const CORPORATE_PARTIES_FAQS = [
  {
    question: "What is a corporate party on a yacht in Mumbai?",
    answer:
      "A corporate party on a yacht in Mumbai is a private company celebration on the water designed for employee engagement, recognition, milestones or festive gatherings.",
  },
  {
    question: "Is a yacht a good venue for an awards ceremony?",
    answer:
      "Yes. A yacht offers a more premium and memorable setting for awards ceremonies, recognition events and company milestones.",
  },
  {
    question: "What types of companies book yacht celebrations?",
    answer:
      "Startups, SMEs, large corporates, sales teams, leadership teams and businesses planning recognition or festive events can all use this format.",
  },
  {
    question: "What can happen during a corporate party or awards ceremony?",
    answer:
      "Companies often use the format for awards presentations, team celebrations, recognition moments, networking, festive gatherings and premium hosted events.",
  },
  {
    question: "How is Indiaboats different for corporate celebrations?",
    answer:
      "Indiaboats focuses on premium on-water experiences and helps companies create polished, memorable and professionally managed corporate events.",
  },
  {
    question: "Is this better than a hotel or banquet hall?",
    answer:
      "For many companies, yes. A yacht creates a more distinctive and memorable setting with stronger guest impression and better recall value.",
  },
  {
    question: "Can this be used for employee recognition and reward events?",
    answer:
      "Yes. Yacht-based celebrations are especially strong for employee recognition, team milestones and reward experiences.",
  },
  {
    question: "How do I enquire about a corporate party or awards ceremony in Mumbai?",
    answer:
      "You can enquire through WhatsApp or the contact form and share your preferred date, guest count and event objective.",
  },
];

const CORPORATE_NETWORKING_FAQS = [
  {
    question: "What is a corporate networking event on a yacht in Mumbai?",
    answer:
      "A corporate networking event on a yacht in Mumbai is a premium business gathering on the water designed for client hosting, executive interaction, partner engagement and professional relationship-building.",
  },
  {
    question: "Why is a yacht good for business networking?",
    answer:
      "A yacht creates a more premium, memorable and private setting than a routine venue, which helps guests feel more engaged and leaves a stronger business impression.",
  },
  {
    question: "What is the difference between a corporate networking event and a regular business event?",
    answer:
      "A regular business event is usually hosted in a standard venue, while a networking event on a yacht turns the gathering into a premium hosted experience that feels more exclusive and more memorable.",
  },
  {
    question: "What happens during a corporate networking event on a yacht?",
    answer:
      "The event may include welcome hosting, networking, partner interaction, client conversations, executive engagement and premium business hospitality in a private setting.",
  },
  {
    question: "Is this suitable for client hosting and partner meetings?",
    answer:
      "Yes. Corporate networking events on a yacht work especially well for client appreciation, partner interaction and premium business relationship-building.",
  },
  {
    question: "What business goals can a corporate networking event support?",
    answer:
      "It can support client hosting, executive networking, partner engagement, investor interaction, business hospitality and stronger brand-led relationship-building.",
  },
  {
    question: "How is Indiaboats different for corporate networking events?",
    answer:
      "Indiaboats focuses on premium on-water corporate experiences and helps companies create networking events that feel polished, meaningful and memorable.",
  },
  {
    question: "How do I enquire about a corporate networking event in Mumbai?",
    answer:
      "You can enquire through WhatsApp or the contact form and share your preferred date, guest profile and event objective.",
  },
];

const BIRTHDAY_FAQS = [
  {
    question: "What is a birthday yacht celebration in Mumbai like?",
    answer:
      "A birthday yacht celebration in Mumbai is a private on-water experience where you celebrate with cake, music, sea views and your own group in a more exclusive setting.",
  },
  {
    question: "Is a yacht a good venue for an anniversary celebration?",
    answer:
      "Yes. A yacht anniversary celebration feels romantic, scenic and private, making it a memorable option for couples and families.",
  },
  {
    question: "What can we do during a birthday or anniversary yacht celebration?",
    answer:
      "Guests often enjoy cake cutting, music, photos, private cruising, family time, sunset views and celebration moments with their group.",
  },
  {
    question: "Is this suitable for children and family groups?",
    answer:
      "Yes. Birthday and anniversary yacht celebrations can be suitable for children, adults, couples, families and multi-generation groups.",
  },
  {
    question: "Which yacht should I choose for up to 15 guests?",
    answer:
      "For up to 15 guests, a private yacht charter is usually the best option because it offers a more intimate and comfortable experience.",
  },
  {
    question: "Which yacht should I choose for more than 15 guests?",
    answer:
      "For more than 15 guests, a yacht party format is usually more suitable because it works better for larger celebration groups.",
  },
  {
    question: "How is Indiaboats different for birthday and anniversary celebrations?",
    answer:
      "Indiaboats focuses on premium on-water experiences, helping guests choose the right format and create celebrations that feel smooth, scenic and memorable.",
  },
  {
    question: "How do I enquire about a birthday or anniversary yacht celebration in Mumbai?",
    answer:
      "You can enquire through WhatsApp or the contact form and share your date, guest count and celebration type.",
  },
];

const PRE_WEDDING_FAQS = [
  {
    question: "What is a pre-wedding yacht photoshoot in Mumbai like?",
    answer:
      "A pre-wedding yacht photoshoot in Mumbai is a private couple shoot on the water with sea views, elegant yacht backdrops and a more exclusive atmosphere.",
  },
  {
    question: "Is a yacht a good venue for a pre-wedding shoot?",
    answer:
      "Yes. A yacht offers a premium, romantic and scenic backdrop that makes couple photos feel more elegant and memorable.",
  },
  {
    question: "What can we capture during a yacht photoshoot?",
    answer:
      "Couples often capture portraits, candid moments, sunset shots, romantic videos, save-the-date content and engagement-style visuals.",
  },
  {
    question: "Is a private yacht better for a couple shoot?",
    answer:
      "Yes. For most couples, a private yacht charter creates a more intimate and relaxed environment for the shoot.",
  },
  {
    question: "Can a larger group join the photoshoot?",
    answer:
      "Yes. If your shoot includes a larger group or additional setup requirements, a bigger yacht option may be more suitable.",
  },
  {
    question: "How is Indiaboats different for pre-wedding yacht shoots?",
    answer:
      "Indiaboats focuses on premium on-water experiences and helps couples choose the right yacht format for a visually beautiful and smooth experience.",
  },
  {
    question: "What is the best time for a pre-wedding yacht photoshoot?",
    answer:
      "Many couples prefer golden hour and sunset because the natural light and sea backdrop create softer, more romantic images.",
  },
  {
    question: "How do I enquire about a pre-wedding yacht photoshoot in Mumbai?",
    answer:
      "You can enquire through WhatsApp or the contact form and share your preferred date, expected group size and shoot requirements.",
  },
];

const FAMILY_FAQS = [
  {
    question: "What is a family yacht party in Mumbai like?",
    answer:
      "A family yacht party in Mumbai is a private on-water experience where families and close groups spend quality time together in a scenic and exclusive setting.",
  },
  {
    question: "Is a private yacht party suitable for family groups?",
    answer:
      "Yes. A private yacht party is ideal for family gatherings, private celebrations and meaningful time with loved ones.",
  },
  {
    question: "What can we do during a family yacht party?",
    answer:
      "Guests often enjoy private cruising, family time, photos, music, sunset views and celebration moments with their group.",
  },
  {
    question: "Which yacht should I choose for up to 15 guests?",
    answer:
      "For up to 15 guests, a private yacht charter is usually the best option because it feels more intimate and comfortable.",
  },
  {
    question: "Which yacht should I choose for more than 15 guests?",
    answer:
      "For more than 15 guests, a yacht party format is usually more suitable because it works better for larger private groups.",
  },
  {
    question: "Is this suitable for multi-generation family groups?",
    answer:
      "Yes. Family yacht parties can work very well for parents, children, grandparents and mixed-age groups.",
  },
  {
    question: "How is Indiaboats different for family and private celebrations?",
    answer:
      "Indiaboats focuses on premium on-water experiences and helps guests choose the right format for smooth, scenic and memorable private outings.",
  },
  {
    question: "How do I enquire about a family or private yacht party in Mumbai?",
    answer:
      "You can enquire through WhatsApp or the contact form and share your date, guest count and occasion.",
  },
];

const PACKAGE_FAQS = [
  {
    question: "What is the difference between a package and a basic charter?",
    answer:
      "A curated package offers a more complete experience and may include route planning, food, beverages, transport, sightseeing or celebration elements, while a basic charter is usually only the boat booking.",
  },
  {
    question: "What kinds of packages are available?",
    answer:
      "Packages may include Mandwa trips, Elephanta outings, sailing experiences, private celebration packages and full-day charter formats.",
  },
  {
    question: "Can a package include premium food and beverages?",
    answer:
      "Yes. Depending on the package, premium food, beverages and other curated inclusions may be part of the experience.",
  },
  {
    question: "Are these packages directly bookable?",
    answer:
      "Yes — you can book packages directly from the listings, with a full details page for each option.",
  },
  {
    question: "Who are these packages best suited for?",
    answer:
      "They are ideal for guests who want a more seamless, more premium and more fully planned on-water experience.",
  },
  {
    question: "Can I compare multiple package types on one page?",
    answer:
      "Yes — Indiaboats lists multiple curated packages in one place so you can compare routes, inclusions and experiences before booking.",
  },
  {
    question: "Are there destination-based packages for Mandwa and Elephanta?",
    answer:
      "Yes — we offer destination-led packages for Mandwa and Elephanta, as well as sailing, celebration and full charter formats.",
  },
  {
    question: "How do I choose the right package?",
    answer:
      "Choose based on your destination, group size, duration and the type of experience you want. Indiaboats can also help recommend the right package.",
  },
];

export const CONTACT_FAQS = [
  {
    question: "How do I book a yacht with Indiaboats?",
    answer:
      "Share your date, number of guests and preferred experience by phone, WhatsApp or enquiry form. Our team will recommend suitable options.",
  },
  {
    question: "Can you help me choose the right yacht or boat?",
    answer:
      "Yes. We can suggest options based on group size, occasion, destination and budget.",
  },
  {
    question: "Can I book speed boats to Mandwa or Elephanta?",
    answer:
      "Yes. Private speed boat options are available from Mumbai, subject to weather, sea conditions and availability.",
  },
  {
    question: "Do you handle corporate events?",
    answer:
      "Yes. Indiaboats organises corporate sailing regattas, yacht parties, networking events and customised corporate experiences.",
  },
];

export const ABOUT_FAQS = [
  {
    question: "What is Indiaboats?",
    answer:
      "Indiaboats is a yacht charter, boat rental and marine experience company offering private yacht charters, sailing experiences, speed boat transfers, yacht parties, curated packages and corporate events in Mumbai and Goa.",
  },
  {
    question: "When was Indiaboats founded?",
    answer:
      "Indiaboats was founded in August 2016 with the aim of creating safer, smoother and more memorable experiences on the water.",
  },
  {
    question: "Who founded Indiaboats?",
    answer:
      "Indiaboats was founded by Mehul Ashar, an experienced sailor with more than 35 years at sea, a decorated national sailing champion who has represented India at prestigious Asian Sailing Regattas and World Championships.",
  },
  {
    question: "Where does Indiaboats operate?",
    answer:
      "Indiaboats offers yacht, sailing and boat experiences primarily in Mumbai and Goa, including private trips to Mandwa, Alibaug and Elephanta from Mumbai.",
  },
  {
    question: "What types of yachts and boats does Indiaboats offer?",
    answer:
      "Indiaboats offers sail boats, compact yachts, mid size yachts, premium yachts, bigger yachts, party yachts, catamarans and speed boats for different group sizes and occasions.",
  },
  {
    question: "Is guest safety important at Indiaboats?",
    answer:
      "Yes. Guest safety is a central part of every Indiaboats experience. Operations are planned around experienced crew, vessel suitability, weather, sea conditions and captain safety clearance.",
  },
  {
    question: "Does Indiaboats arrange private celebrations and corporate events?",
    answer:
      "Yes. Indiaboats arranges private celebrations, birthdays, anniversaries, proposals, pre-wedding shoots, family outings, yacht parties, corporate sailing regattas, networking events and company celebrations.",
  },
  {
    question: "Why choose Indiaboats?",
    answer:
      "Indiaboats combines an extensive fleet, experienced marine operations, personalised planning and a strong focus on safety, comfort and memorable guest experiences.",
  },
];

export const ALIBAUG_ELEPHANTA_FAQS = [
  {
    question: "How do I travel from Mumbai to Alibaug by private boat?",
    answer:
      "Private speed boats operate from Mumbai to Mandwa. From Mandwa, guests can continue by road to Alibaug and nearby destinations.",
  },
  {
    question: "Can I book a private speed boat from Mumbai to Mandwa?",
    answer:
      "Yes. Indiaboats offers private speed boats in multiple seating capacities for Mumbai to Mandwa travel.",
  },
  {
    question: "Can I travel privately from Mumbai to Elephanta Island?",
    answer:
      "Yes. Private speed boat options are available for Elephanta trips, subject to operating conditions and permissions.",
  },
  {
    question: "How many people can travel on a speed boat?",
    answer:
      "Indiaboats offers boats for groups ranging from approximately 5 guests to 20 guests, with larger-capacity options available for bigger groups.",
  },
  {
    question: "Can Indiaboats arrange a full-day Alibaug package?",
    answer:
      "Yes. Curated Mandwa and Alibaug packages can include private boat transfers and local transportation.",
  },
  {
    question: "Do you offer guided Elephanta packages?",
    answer:
      "Curated Elephanta packages can include private boat transfers, required permissions and a local guide.",
  },
  {
    question: "Are boat trips available throughout the year?",
    answer:
      "Operations are subject to weather, monsoon restrictions, sea conditions, government regulations and captain safety clearance.",
  },
  {
    question: "Where can I book the speed boat?",
    answer:
      "You can view available boat sizes and booking options on the Indiaboats Speed Boat Transfer page.",
  },
];

const CORPORATE_EVENTS_FAQS = [
  {
    question: "What types of corporate events does Indiaboats offer?",
    answer:
      "Indiaboats offers corporate sailing regattas, corporate yacht parties and corporate networking events in Mumbai.",
  },
  {
    question: "What is a corporate sailing regatta?",
    answer:
      "A corporate sailing regatta is a team-building sailing experience where employees or business groups participate in a structured on-water activity designed to build teamwork, leadership and communication.",
  },
  {
    question: "Is a yacht a good venue for a corporate party?",
    answer:
      "Yes. A yacht offers a more premium, private and memorable setting for company celebrations, annual gatherings and employee recognition events.",
  },
  {
    question: "Why choose a yacht for a networking event?",
    answer:
      "A yacht creates a stronger business impression and offers a more distinctive environment for hosting clients, partners and executive guests.",
  },
  {
    question: "Which corporate format is best for team building?",
    answer:
      "Corporate sailing regattas are usually the best choice for team building because they encourage active participation and collaboration.",
  },
  {
    question: "Which corporate format is best for company celebrations?",
    answer:
      "Corporate yacht parties are usually the best choice for annual parties, festive gatherings and recognition-led events.",
  },
  {
    question: "Which corporate format is best for client hosting and networking?",
    answer:
      "Corporate networking events on a yacht are usually the best fit for client hosting, partner interaction and premium business hospitality.",
  },
  {
    question: "How do I enquire about a corporate event in Mumbai?",
    answer:
      "You can enquire through WhatsApp or the contact form and share your preferred date, guest count and event objective.",
  },
];

const serviceAndFaq = (serviceType, description, faqs) => [
  buildServiceSchema(serviceType, description),
  buildFaqSchema(faqs),
];

export const PAGE_SCHEMAS = {
  home: HOME_PAGE_SCHEMA,
  about: [buildFaqSchema(ABOUT_FAQS), MEHUL_ASHAR_PERSON_SCHEMA],
  contact: [LOCAL_BUSINESS_REFERENCE, buildFaqSchema(CONTACT_FAQS)],
  packages: serviceAndFaq(
    "Curated Yacht & Boat Packages",
    "Browse curated packages — Mandwa day trips, Elephanta Island tours, premium sailing and sunset sails. Complete end-to-end experiences.",
    PACKAGE_FAQS
  ),
  privateYachtCharter: serviceAndFaq(
    "Private Yacht Charter",
    "Book a private yacht charter in Mumbai or Goa for up to 15 guests. Compare Luxury and Explore fleets, pricing and inclusions.",
    PRIVATE_YACHT_FAQS
  ),
  yachtPartyMumbai: serviceAndFaq(
    "Yacht Party Charter",
    "Host a yacht party in Mumbai for 15 or more guests. Large party yachts for birthdays, celebrations and group events.",
    YACHT_PARTY_FAQS
  ),
  speedBoat: serviceAndFaq(
    "Speed Boat Transfer",
    "Book a private or shared speed boat transfer from Mumbai to Alibaug or Mandwa. Quick, comfortable, reliable — skip the road traffic.",
    SPEED_BOAT_FAQS
  ),
  corporateSailingRegatta: serviceAndFaq(
    "Corporate Sailing Regatta",
    "Run a corporate sailing regatta in Mumbai for team building, leadership training or client entertainment. Custom B2B packages.",
    REGATTA_FAQS
  ),
  corporatePartyAwards: serviceAndFaq(
    "Corporate Party & Awards Yacht",
    "Celebrate company milestones, awards nights and corporate parties on a private yacht in Mumbai — a more memorable setting than a banquet hall.",
    CORPORATE_PARTIES_FAQS
  ),
  corporateEventsNetworking: serviceAndFaq(
    "Corporate Yacht Networking Event",
    "Host a corporate yacht event in Mumbai for client entertainment, business networking or team celebrations. Full event coordination.",
    CORPORATE_NETWORKING_FAQS
  ),
  birthdayAnniversary: serviceAndFaq(
    "Birthday & Anniversary Yacht Celebration",
    "Celebrate a birthday or anniversary on a private yacht in Mumbai — cake-cutting, music, sunset views and photos.",
    BIRTHDAY_FAQS
  ),
  preWedding: serviceAndFaq(
    "Pre-Wedding Yacht Photoshoot",
    "Book a private yacht for your pre-wedding photoshoot in Mumbai. Stunning sea backdrops and skyline views for a romantic shoot.",
    PRE_WEDDING_FAQS
  ),
  familyPrivateYachtParty: serviceAndFaq(
    "Family Yacht Party",
    "Plan a private family yacht outing in Mumbai — away from the crowds, with comfort, privacy and sea views.",
    FAMILY_FAQS
  ),
  corporateEvents: [
    buildServiceSchema(
      "Corporate Yacht Events",
      "Plan corporate yacht events, sailing regattas, networking experiences, awards evenings and company celebrations in Mumbai with Indiaboats. Premium on-water events with smooth planning and guest safety."
    ),
    buildFaqSchema(CORPORATE_EVENTS_FAQS),
    buildBreadcrumbSchema([
      { name: "Home", url: "https://www.indiaboats.in/" },
      {
        name: "Corporate Events",
        url: "https://www.indiaboats.in/corporate-events",
      },
    ]),
    ORGANIZATION_REFERENCE,
  ],
  alibaugElephantaBoatTours: [
    buildServiceSchema(
      "Alibaug & Elephanta Boat Tours",
      "Book private boat trips from Mumbai to Alibaug, Mandwa and Elephanta with Indiaboats. Enjoy fast speed boat transfers, scenic island escapes and curated day experiences."
    ),
    buildFaqSchema(ALIBAUG_ELEPHANTA_FAQS),
    buildBreadcrumbSchema([
      { name: "Home", url: "https://www.indiaboats.in/" },
      {
        name: "Alibaug & Elephanta Boat Tours",
        url: "https://www.indiaboats.in/alibaug-elephanta-boat-tours-mumbai",
      },
    ]),
  ],
  guideSailingYachtVsMotorYacht: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Sailing Yacht vs Motor Yacht: Which Should You Choose?",
      serviceType: "Sailing Yacht vs Motor Yacht: Which Should You Choose?",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/guides/sailing-yacht-vs-motor-yacht",
      description:
        "The practical differences between a sailing yacht and a motor yacht, to help you choose the right charter.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Which is better for a celebration — sailing or motor yacht?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "A motor yacht is usually the simpler choice for a party or celebration, since the ride is steadier and more predictable.",
          },
        },
        {
          "@type": "Question",
          name: "Which is better if I want to experience real sailing?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "A sailing yacht, like NEMO, gives you the genuine experience of sailing under wind power.",
          },
        },
        {
          "@type": "Question",
          name: "Is one safer than the other?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Both are operated by trained crew with full safety equipment. Your choice should come down to the kind of experience you want, not safety.",
          },
        },
        {
          "@type": "Question",
          name: "Can I try sailing without committing to a full lesson?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Yes — a private charter on a sailing yacht gives you a taste of it, or see our Learn to Sail page for a more hands-on session.",
          },
        },
      ],
    },
    buildGuideBreadcrumbSchema(
      "Sailing Yacht vs Motor Yacht",
      "https://www.indiaboats.in/guides/sailing-yacht-vs-motor-yacht"
    ),
  ],
  guideFirstYachtRideTips: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "First Time on a Yacht: What to Expect",
      serviceType: "First Time on a Yacht: What to Expect",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/guides/first-yacht-ride-tips",
      description:
        "Practical tips for your first private yacht charter in Mumbai — what to wear, what to bring and what happens on board.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Is a life jacket provided?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Yes, a life jacket is available for every guest, and a safety briefing is given before departure.",
          },
        },
        {
          "@type": "Question",
          name: "What should I wear?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Comfortable, casual clothing and flat, deck-friendly shoes.",
          },
        },
        {
          "@type": "Question",
          name: "What if I get seasick easily?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Consider a precaution before boarding and let the crew know — they can suggest the steadiest spot on the boat.",
          },
        },
        {
          "@type": "Question",
          name: "How early should I arrive?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "20 to 30 minutes before departure, for boarding and the safety briefing.",
          },
        },
      ],
    },
    buildGuideBreadcrumbSchema(
      "First Time on a Yacht",
      "https://www.indiaboats.in/guides/first-yacht-ride-tips"
    ),
  ],
  guideYachtProposalChecklist: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Planning a Yacht Proposal: The Checklist",
      serviceType: "Planning a Yacht Proposal: The Checklist",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/guides/yacht-proposal-checklist",
      description:
        "A step-by-step checklist for planning a marriage proposal on a private yacht in Mumbai.",
    },
    {
      "@context": "https://schema.org",
      "@type": "HowTo",
      name: "Planning a Yacht Proposal: The Checklist",
      step: [
        {
          "@type": "HowToStep",
          position: 1,
          name: "Pick your moment",
          text:
            "Decide whether you want sunset, a specific view (like the Mumbai skyline), or simply open water. Tell us your preference and we will suggest the best timing.",
        },
        {
          "@type": "HowToStep",
          position: 2,
          name: "Decide on extras",
          text:
            "Flowers, a cake, music or a specific decor setup can all be arranged on request — let us know what you are picturing.",
        },
        {
          "@type": "HowToStep",
          position: 3,
          name: "Plan for privacy",
          text:
            "Tell us if you want the crew to step back for the moment itself. We brief the team in advance so it feels completely private.",
        },
        {
          "@type": "HowToStep",
          position: 4,
          name: "Think about the ring",
          text:
            "Consider how and where you will keep the ring safe until the moment — a secure pocket or a crew member holding it until you signal.",
        },
        {
          "@type": "HowToStep",
          position: 5,
          name: "Have a backup plan for weather",
          text:
            "Ask us about options if conditions change on the day — we will help you adjust timing if needed.",
        },
        {
          "@type": "HowToStep",
          position: 6,
          name: "Book early",
          text:
            "For a specific date or sunset timing, book at least a week in advance to secure the right boat and slot.",
        },
        {
          "@type": "HowToStep",
          position: 7,
          name: "Decide who else will know",
          text:
            "If you want photos or a surprise element involving family or friends, tell us when you enquire so we can help coordinate.",
        },
      ],
    },
    buildGuideBreadcrumbSchema(
      "Yacht Proposal Checklist",
      "https://www.indiaboats.in/guides/yacht-proposal-checklist"
    ),
  ],
  guideElephantaBySpeedBoat: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Getting to Elephanta Caves by Speed Boat",
      serviceType: "Getting to Elephanta Caves by Speed Boat",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/guides/elephanta-by-speed-boat",
      description:
        "A practical guide to visiting Elephanta Caves from Mumbai by private speed boat — timing, permissions and what to expect.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "How long does it take to reach Elephanta by speed boat?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "About 35 to 40 minutes each way from Gateway of India.",
          },
        },
        {
          "@type": "Question",
          name: "Do I need a separate permit for the caves?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "No — the required island entry permission is arranged as part of your private transfer booking.",
          },
        },
        {
          "@type": "Question",
          name: "How much time do I get at the island?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Up to 3 hours of waiting time is included with a private return transfer.",
          },
        },
        {
          "@type": "Question",
          name: "What does the trip cost?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "A private return transfer, including permission and waiting time, starts at ₹15,000.",
          },
        },
        {
          "@type": "Question",
          name: "Does this run year-round?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "No — speed boat services pause during the Mumbai monsoon, roughly late May to end of August.",
          },
        },
      ],
    },
    buildGuideBreadcrumbSchema(
      "Elephanta by Speed Boat",
      "https://www.indiaboats.in/guides/elephanta-by-speed-boat"
    ),
  ],
  guideAlibaugSpeedBoatVsFerry: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Alibaug Speed Boat vs the Ferry: Which Should You Take?",
      serviceType: "Alibaug Speed Boat vs the Ferry: Which Should You Take?",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/guides/alibaug-speed-boat-vs-ferry",
      description:
        "Comparing a private speed boat and the public ferry for getting from Mumbai to Alibaug or Mandwa.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "How long does the private speed boat take compared to the ferry?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "A private speed boat takes about 20–25 minutes crossing time. Ferry journey times vary — check with the ferry operator for current timing.",
          },
        },
        {
          "@type": "Question",
          name: "Can I book a one-way speed boat transfer?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. One-way and return transfers are both available.",
          },
        },
        {
          "@type": "Question",
          name: "Is the speed boat available every day?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, outside the monsoon season (roughly late May to end of August), when all Mumbai boating pauses.",
          },
        },
        {
          "@type": "Question",
          name: "How do I book a private transfer to Alibaug?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "WhatsApp +91 85919 83301 or call +91 85919 93301 with your date and group size.",
          },
        },
      ],
    },
    buildGuideBreadcrumbSchema(
      "Alibaug Speed Boat vs Ferry",
      "https://www.indiaboats.in/guides/alibaug-speed-boat-vs-ferry"
    ),
  ],
  guideYachtPartyCostMumbai: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "How Much Does a Yacht Party Cost in Mumbai?",
      serviceType: "How Much Does a Yacht Party Cost in Mumbai?",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/guides/yacht-party-cost-mumbai",
      description:
        "A plain-English guide to what drives the price of a yacht party or private yacht charter in Mumbai, with real examples.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What is the cheapest way to get on a yacht in Mumbai?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "A shorter charter (2 hours) on a Mid Size Yacht is typically the most budget-friendly private option, starting from ₹10,000.",
          },
        },
        {
          "@type": "Question",
          name: "Do prices include GST?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The prices quoted on our site are exclusive of GST unless stated otherwise. We will confirm the full, final amount when you book.",
          },
        },
        {
          "@type": "Question",
          name: "Does group size change the price?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes — larger groups may need a bigger boat (a different category) or our Yacht Party format, which is priced separately.",
          },
        },
        {
          "@type": "Question",
          name: "How do I get an exact quote?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Contact us on WhatsApp +91 85919 83301 or call +91 85919 93301 with your date, guest count and what you are celebrating.",
          },
        },
      ],
    },
    buildGuideBreadcrumbSchema(
      "Yacht Party Cost in Mumbai",
      "https://www.indiaboats.in/guides/yacht-party-cost-mumbai"
    ),
  ],
  fleetAaniaa: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "AANIAA: 8-Seater Private Speed Boat",
      serviceType: "AANIAA: 8-Seater Private Speed Boat",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/fleet/aaniaa",
      description:
        "AANIAA is India Boats' 21 ft private speed boat in Mumbai, for transfers to Mandwa, Alibaug and Elephanta.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What kind of boat is AANIAA?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "A 21 ft private speed boat, for up to 8 guests.",
          },
        },
        {
          "@type": "Question",
          name: "Which routes does AANIAA cover?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Mumbai to Mandwa/Alibaug (about 20–25 minutes) and Mumbai to Elephanta (about 35–40 minutes, with island permission and waiting time included on the return trip).",
          },
        },
        {
          "@type": "Question",
          name: "What does an AANIAA transfer cost?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "From ₹9,000 one-way to Mandwa/Alibaug, or from ₹15,000 for a private return transfer to Elephanta.",
          },
        },
        {
          "@type": "Question",
          name: "Where does AANIAA depart from?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Gateway of India / Jetty No. 5, Mumbai.",
          },
        },
        {
          "@type": "Question",
          name: "How do I book AANIAA?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "WhatsApp +91 85919 83301 or call +91 85919 93301 with your date, route and guest count.",
          },
        },
      ],
    },
    buildFleetBreadcrumbSchema(
      "AANIAA",
      "https://www.indiaboats.in/fleet/aaniaa"
    ),
  ],
  fleetAriel: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Ariel: Mid Size Private Yacht in Mumbai",
      serviceType: "Ariel: Mid Size Private Yacht in Mumbai",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/fleet/ariel",
      description:
        "Ariel is India Boats' Mid Size Yacht in Mumbai — a 29 ft Malbec 290, for up to 8 guests.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What kind of boat is Ariel?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "A 29 ft Malbec 290, built in Argentina — our Mid Size Yacht category.",
          },
        },
        {
          "@type": "Question",
          name: "How many guests can Ariel carry?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Up to 8 guests for a private charter.",
          },
        },
        {
          "@type": "Question",
          name: "What does an Ariel charter cost?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "₹10,000 for 2 hours (excluding GST). Longer charters can be arranged — contact us for pricing.",
          },
        },
        {
          "@type": "Question",
          name: "Where does Ariel depart from?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Gateway of India / Jetty No. 5, Mumbai.",
          },
        },
        {
          "@type": "Question",
          name: "How do I book Ariel?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "WhatsApp +91 85919 83301 or call +91 85919 93301 with your date and guest count.",
          },
        },
      ],
    },
    buildFleetBreadcrumbSchema(
      "Ariel",
      "https://www.indiaboats.in/fleet/ariel"
    ),
  ],
  fleetNemo: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "NEMO: Jeanneau Sun Odyssey 36 Sailing Yacht",
      serviceType: "NEMO: Jeanneau Sun Odyssey 36 Sailing Yacht",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/fleet/nemo",
      description:
        "NEMO is India Boats' Jeanneau Sun Odyssey 36 sailing yacht in Mumbai — our Large Size Yacht category, for up to 10 guests.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What kind of boat is NEMO?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "A Jeanneau Sun Odyssey 36 — a sailing yacht in our Large Size Yacht category.",
          },
        },
        {
          "@type": "Question",
          name: "How many guests can NEMO carry?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Up to 10 guests for a private charter.",
          },
        },
        {
          "@type": "Question",
          name: "What does a NEMO charter cost?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "₹15,000 for 2 hours (excluding GST). Longer charters can be arranged — contact us for pricing.",
          },
        },
        {
          "@type": "Question",
          name: "Where does NEMO depart from?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Gateway of India / Jetty No. 5, Mumbai.",
          },
        },
        {
          "@type": "Question",
          name: "How do I book NEMO?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "WhatsApp +91 85919 83301 or call +91 85919 93301 with your date and guest count.",
          },
        },
      ],
    },
    buildFleetBreadcrumbSchema(
      "NEMO",
      "https://www.indiaboats.in/fleet/nemo"
    ),
  ],
  sunsetCruiseGoa: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Private Sunset Yacht Cruise in Goa",
      serviceType: "Private Sunset Yacht Cruise in Goa",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/sunset-cruise-goa",
      description:
        "Private sunset yacht cruise in Goa with India Boats. Contact us for current boats, timing and pricing.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What time does the Goa sunset cruise depart?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Timing changes through the year to match sunset. Tell us your date and we will confirm the exact slot.",
          },
        },
        {
          "@type": "Question",
          name: "How long does the cruise last?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Most sunset cruises run 1.5 to 2 hours. We will confirm exact timing when you enquire.",
          },
        },
        {
          "@type": "Question",
          name: "How do I book?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "WhatsApp +91 85919 83301 or call +91 85919 93301 with your date and group size.",
          },
        },
      ],
    },
  ],
  yachtPartyGoa: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Yacht Parties in Goa",
      serviceType: "Yacht Parties in Goa",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/yacht-party-goa",
      description:
        "Host a yacht party in Goa with India Boats. Contact us for current boats, capacities and pricing for larger groups.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "How many guests can a Goa yacht party hold?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our Yacht Party format is for groups of more than 15 guests. Tell us your exact number and we will confirm the right boat.",
          },
        },
        {
          "@type": "Question",
          name: "What does a Goa yacht party cost?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Pricing depends on the boat, duration and group size. Contact us for a confirmed quote.",
          },
        },
        {
          "@type": "Question",
          name: "Can music and catering be arranged?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, on request — tell us what you are planning when you enquire.",
          },
        },
        {
          "@type": "Question",
          name: "How do I book?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "WhatsApp +91 85919 83301 or call +91 85919 93301 with your date and group size.",
          },
        },
      ],
    },
  ],
  yachtRentalGoa: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Private Yacht Rental in Goa",
      serviceType: "Private Yacht Rental in Goa",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/yacht-rental-goa",
      description:
        "Private yacht rental in Goa with India Boats. Contact us for current boats, capacities and pricing.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What yachts are available in Goa?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Availability varies — contact us with your dates and group size and we will confirm current options.",
          },
        },
        {
          "@type": "Question",
          name: "What is the price for a private charter in Goa?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Pricing depends on the boat and duration. Get in touch for a confirmed quote.",
          },
        },
        {
          "@type": "Question",
          name: "Is Goa boating available year-round?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Availability can be seasonal. Contact us and we will confirm the current operating window.",
          },
        },
        {
          "@type": "Question",
          name: "How do I book?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "WhatsApp +91 85919 83301 or call +91 85919 93301 with your dates and group size.",
          },
        },
      ],
    },
  ],
  sailWithAChampionMumbai: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Sail with a National Sailing Champion in Mumbai",
      serviceType: "Sail with a National Sailing Champion in Mumbai",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/sail-with-a-champion-mumbai",
      description:
        "Sail in Mumbai with decorated national sailing champion Mehul Ashar, founder of India Boats, with more than 35 years of competitive sailing experience.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What makes this different from a regular sailing session?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "It is built around India Boats' own sailing background — more than 35 years of competitive experience, including Asian regattas and World Championships.",
          },
        },
        {
          "@type": "Question",
          name: "Who is this suited for?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Guests who already have an interest in sailing, or who want a more serious, hands-on experience than a standard leisure charter.",
          },
        },
        {
          "@type": "Question",
          name: "How do I check availability and pricing?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Contact us on WhatsApp +91 85919 83301 or call +91 85919 93301 and our team will confirm current details.",
          },
        },
      ],
    },
  ],
  learnSailingMumbai: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Learn to Sail in Mumbai",
      serviceType: "Learn to Sail in Mumbai",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/learn-sailing-mumbai",
      description:
        "Learn to sail in Mumbai with India Boats, founded by decorated national sailing champion Mehul Ashar.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Do I need any experience to start?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "No. Sessions are suited to complete beginners as well as those with some prior experience.",
          },
        },
        {
          "@type": "Question",
          name: "Who will be teaching?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "India Boats was founded by national sailing champion Mehul Ashar, with more than 35 years of competitive sailing experience.",
          },
        },
        {
          "@type": "Question",
          name: "What should I bring?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Comfortable clothing and non-marking shoes. We will confirm any other requirements when you enquire.",
          },
        },
        {
          "@type": "Question",
          name: "How do I find out pricing and the next available session?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Contact us on WhatsApp +91 85919 83301 or call +91 85919 93301 and our team will confirm current availability and pricing.",
          },
        },
      ],
    },
  ],
  bachelorPartyYachtMumbai: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Bachelor & Bachelorette Yacht Parties in Mumbai",
      serviceType: "Bachelor & Bachelorette Yacht Parties in Mumbai",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/bachelor-party-yacht-mumbai",
      description:
        "Host a bachelor or bachelorette party on a yacht in Mumbai. Private charters and larger party yachts for groups of friends.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "How many people can come on a bachelor/bachelorette yacht party?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "For up to 15 guests, book a private yacht charter. For larger groups, our Yacht Party format fits 15 or more.",
          },
        },
        {
          "@type": "Question",
          name: "Can we bring our own music and decorations?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, within the boat's safety guidelines. Tell us your plans when you enquire.",
          },
        },
        {
          "@type": "Question",
          name: "Is alcohol allowed on board?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Policies vary by boat and are explained at the time of booking — ask our team when you enquire.",
          },
        },
        {
          "@type": "Question",
          name: "How long is a typical party charter?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Most parties run 3 to 4 hours, though longer charters can be arranged.",
          },
        },
        {
          "@type": "Question",
          name: "How do we book?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "WhatsApp +91 79 7757 4228 or call +91 85919 93301 with your group size, date and what you are planning.",
          },
        },
      ],
    },
  ],
  yachtProposalMumbai: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Plan a Marriage Proposal on a Private Yacht in Mumbai",
      serviceType: "Plan a Marriage Proposal on a Private Yacht in Mumbai",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/yacht-proposal-mumbai",
      description:
        "Plan a marriage proposal on a private yacht in Mumbai. Open sea, a private deck and a moment with no interruptions.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can the crew stay out of sight during the proposal?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. We brief the crew in advance so they give you full privacy at the moment you choose.",
          },
        },
        {
          "@type": "Question",
          name: "Can you arrange flowers, a cake or decorations?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, on request. Tell us what you have in mind when you enquire and we will quote it separately.",
          },
        },
        {
          "@type": "Question",
          name: "What is the best time of day for a proposal cruise?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Many couples choose sunset for the light, but a private charter can run at any time of day.",
          },
        },
        {
          "@type": "Question",
          name: "How far in advance should I book?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We recommend booking at least a week ahead, especially for a specific date or sunset timing.",
          },
        },
        {
          "@type": "Question",
          name: "How do I keep this a surprise?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Let us know when you enquire — we can coordinate discreetly, including separate communication if needed.",
          },
        },
      ],
    },
  ],
  couplesYachtMumbai: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "A Private Yacht for Two in Mumbai",
      serviceType: "A Private Yacht for Two in Mumbai",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/couples-yacht-mumbai",
      description:
        "A private yacht charter for two in Mumbai — an intimate day or evening on the water for couples, anniversaries and proposals.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Is this only for couples, or can a small group book too?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "It is designed around couples, but a small group of 3–4 can also book the same category of boat.",
          },
        },
        {
          "@type": "Question",
          name: "Can you help plan a proposal on board?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes — see our dedicated proposal page, or mention it when you enquire and we will help plan the setup.",
          },
        },
        {
          "@type": "Question",
          name: "How long does a couple's charter run?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Typically 2 to 3 hours, though longer charters can be arranged.",
          },
        },
        {
          "@type": "Question",
          name: "What is included?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The private charter and crew. Catering, music and decor can be added — tell us what you would like when you enquire.",
          },
        },
        {
          "@type": "Question",
          name: "How do I book?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "WhatsApp +91 79 7757 4228 or call +91 85919 93301 with your date and what you have in mind.",
          },
        },
      ],
    },
  ],
  yachtBookingGatewayOfIndia: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Book a Private Yacht at the Gateway of India",
      serviceType: "Book a Private Yacht at the Gateway of India",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/yacht-booking-gateway-of-india",
      description:
        "Book a private yacht, speed boat or sunset cruise departing from the Gateway of India, Mumbai. Jetty No. 5, private charters for every group size.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Where exactly do I board?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "At Jetty No. 5, near the Gateway of India, Mumbai. We send exact boarding instructions after you book.",
          },
        },
        {
          "@type": "Question",
          name: "What can I book from here?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Private yacht charters, yacht parties, speed boat transfers to Mandwa, Alibaug and Elephanta, sunset cruises and curated packages.",
          },
        },
        {
          "@type": "Question",
          name: "Is parking available near the jetty?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Paid parking is available in the Gateway of India area. We can share the latest guidance when you book.",
          },
        },
        {
          "@type": "Question",
          name: "How early should I arrive?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We recommend arriving 20 to 30 minutes before your departure time for boarding and the safety briefing.",
          },
        },
        {
          "@type": "Question",
          name: "How do I book?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Call +91 85919 93301 or WhatsApp +91 79 7757 4228 with your date, group size and what you would like to do on the water.",
          },
        },
      ],
    },
  ],
  speedBoatMumbaiToMandwa: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Private Speed Boat from Mumbai to Mandwa & Alibaug",
      serviceType: "Private Speed Boat from Mumbai to Mandwa & Alibaug",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/speed-boat-mumbai-to-mandwa",
      description:
        "Private speed boat transfer from Mumbai to Mandwa and Alibaug. About 20–25 minutes each way — skip the three-hour road journey.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "How long is the crossing to Mandwa or Alibaug?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "About 20 to 25 minutes by private speed boat, against three hours or more by road.",
          },
        },
        {
          "@type": "Question",
          name: "Can I book a one-way transfer?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. One-way and return transfers are both available on this route.",
          },
        },
        {
          "@type": "Question",
          name: "How much does it cost?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "A one-way private transfer starts at ₹9,000. Contact us with your group size and date for a confirmed quote.",
          },
        },
        {
          "@type": "Question",
          name: "How many guests can travel together?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Up to 8 guests on our AANIAA speed boat for this route.",
          },
        },
        {
          "@type": "Question",
          name: "Where do I board in Mumbai?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Transfers depart from Gateway of India / Jetty No. 5. We confirm the exact boarding time when you book.",
          },
        },
        {
          "@type": "Question",
          name: "Does this run during the monsoon?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "No. Speed boat services pause during the Mumbai monsoon, roughly late May to end of August.",
          },
        },
      ],
    },
  ],
  speedBoatMumbaiToElephanta: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Private Speed Boat from Mumbai to Elephanta Caves",
      serviceType: "Private Speed Boat from Mumbai to Elephanta Caves",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/speed-boat-mumbai-to-elephanta",
      description:
        "Private speed boat transfer from Mumbai to Elephanta Caves. 35–40 minutes each way, with island permission and waiting time included.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "How long does the speed boat take to Elephanta?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "About 35 to 40 minutes each way from Gateway of India.",
          },
        },
        {
          "@type": "Question",
          name: "Is the island entry permission included?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. The required permission to dock and visit the caves is arranged as part of the booking.",
          },
        },
        {
          "@type": "Question",
          name: "How much waiting time is included at the island?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Up to 3 hours, so you have time to see the caves without rushing back to the boat.",
          },
        },
        {
          "@type": "Question",
          name: "How many guests can travel together?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Up to 8 guests on our AANIAA speed boat for this route.",
          },
        },
        {
          "@type": "Question",
          name: "What does a private transfer to Elephanta cost?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "A private return transfer starts at ₹15,000, including permission and waiting time. Contact us for a confirmed quote.",
          },
        },
        {
          "@type": "Question",
          name: "Does this run all year?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "No. Speed boat services pause during the Mumbai monsoon, roughly late May to end of August. Contact us for this year's exact dates.",
          },
        },
      ],
    },
  ],
  sunsetCruiseMumbai: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Private Sunset Yacht Cruise in Mumbai",
      serviceType: "Private Sunset Yacht Cruise in Mumbai",
      provider: {
        "@id": "https://www.indiaboats.in/#business",
      },
      areaServed: ["Mumbai", "Goa"],
      url: "https://www.indiaboats.in/sunset-cruise-mumbai",
      description:
        "Book a private sunset yacht cruise in Mumbai, starting from ₹7,500. Golden-hour views of the Mumbai skyline from the water.",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What time does the sunset cruise depart?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Departure time changes through the year to match sunset. Tell us your date and we will confirm the exact slot.",
          },
        },
        {
          "@type": "Question",
          name: "How long does a sunset cruise last?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Most sunset charters run 1.5 to 2 hours, covering the approach, the sunset itself and the return to the jetty.",
          },
        },
        {
          "@type": "Question",
          name: "How many guests can join?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "From a couple up to larger groups, depending on the yacht category you choose. Tell us your group size and we will recommend the right boat.",
          },
        },
        {
          "@type": "Question",
          name: "Is food available on board?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Light refreshments can be arranged on request. Tell us when you enquire and we will include it in your quote.",
          },
        },
        {
          "@type": "Question",
          name: "Does the sunset cruise run during the monsoon?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "No. All boating in Mumbai pauses during the monsoon (roughly late May to end of August). Contact us for this year's exact dates.",
          },
        },
      ],
    },
  ],
};
